module.exports = __webpack_public_path__ + "static/blog74-ba7a78968fbe8fa9c484cb7c7e156f6c.png";